import { UploadFileIllustration } from '../../assets/illustrations';
import Spinner from '../../components/Spinner';
import MotionWrapper from '../MotionWrapper';
// import ProgressBar from '../../components/ProgressBar';
import styles from './style.module.scss';

interface Props {
    progress: number;
    description: string;
};

export default function CollectingData(props: Props) {
    const { progress, description } = props;

    return (
        <MotionWrapper className={styles.wrapper}>
            <div className={styles.content}>
                <UploadFileIllustration />
                <h3>Meritocracy is our passion</h3>
                <span className={styles.description}>
                    {description}
                </span>
                <Spinner />
                {/* <ProgressBar percentage={progress} /> */}
            </div>
        </MotionWrapper>
    )
};
